import { PRODUCT_CODE_KEY } from '@/shared/constants/storage.constants'
// @ts-ignore
import axios, { type AxiosInstance, type AxiosRequestConfig } from 'axios'

const createHttpConfig = (): AxiosRequestConfig => {
  const config: AxiosRequestConfig = {
    baseURL: import.meta.env.VUE_APP_PUBLIC_API_URL,
    withCredentials: true,
  }

  if (import.meta.env.MODE !== 'development') {
    const code = localStorage.getItem(PRODUCT_CODE_KEY) || ''
    if (code) {
      config.headers = { 'QIC-Product-Code': code }
    }
  }

  return config
}

const http: AxiosInstance = axios.create(createHttpConfig())

export const pushEvent = async (
  event: string = 'view_page',
  additionalParams: { [key in string]: string } = {},
  tries: number = 5
): Promise<void> => {
  if (!window?.gaGlobal) {
    if (tries <= 0) {
      console.error('No gaGlobal found')
      return
    }
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve(pushEvent(event, additionalParams, tries - 1))
      }, 500)
    })
  }

  let data = {
    event_name: event,
    path: window.location.pathname,
    url: window.location.href,
    google_id: window.gaGlobal.vid,
    timestamp: Math.floor(Date.now() / 1000).toString(),
  }

  data = { ...data, ...additionalParams }

  try {
    return await http.post('/events/?action=pushevent', new URLSearchParams(data))
  } catch (error) {
    console.error('Failed to push event:', error)
  }
}
